import PptxGenJS from "pptxgenjs";
import { map, meanBy, round, get, times } from "lodash";
import { COLORS, getScoreTableRows, TEXT_OPTIONS } from "../masters/components";
import { TemplateData } from "..";

const LEFT_COLUMN_X = 0.52;
const COLUMN_Y = 2.07;

export const addLeadershipSpanSlide = (pres: PptxGenJS, data: TemplateData) => {
  const slide = pres.addSlide({ masterName: "SPLIT_TOP_THREE_MASTER" });
  slide.addText("Leadership Span", { placeholder: "title" });

  if (data.candidateName) {
    slide.addText(data.candidateName, {
      ...TEXT_OPTIONS.caption,
      x: LEFT_COLUMN_X,
      y: 1.14,
      fontSize: 18,
    });
  }

  const leadershipSpanEvaluations = get(
    data.evaluationRows,
    "Leadership Span",
    []
  );

  const leadershipSpanSummariesTable = [
    map(leadershipSpanEvaluations, (row) => ({
      text: row.title,
      options: { ...TEXT_OPTIONS.caption, align: "left", valign: "middle" },
    })),
    map(leadershipSpanEvaluations, (row) => ({
      text: row.summary?.trim() || "",
      options: { ...TEXT_OPTIONS.bullet, align: "left", valign: "top" },
    })),
  ];

  slide.addTable(leadershipSpanSummariesTable as any, {
    x: LEFT_COLUMN_X,
    y: COLUMN_Y,
    w: 14.96,
    h: 3.35,
    rowH: [0.43, 2.87],
  });

  const tableData = [
    ...getScoreTableRows({
      groupTitle: "Leadership Span",
      rows: map(leadershipSpanEvaluations, (row) => ({
        title: row.title,
        score: round(meanBy(row.evaluations, "evaluation"), 0),
      })),
    }),
  ];

  const tableOptions = {
    x: LEFT_COLUMN_X,
    y: 5.67,
    w: 14.96 / 2 - 0.5,
    h: 2.4,
    fontSize: 12,
    colspan: 5,
    rowH: 0.5,
    colW: [2.94, 1.13, 1.13, 1.13, 1.13],
    fill: COLORS.WHITE,
  } as const;

  slide.addTable(tableData as any, tableOptions as any);

  const getSpanScoreCells = (score: number, reverse: boolean = false) => {
    const cells = times(4, (i) => ({
      text: "",
      options: {
        colspan: 1,
        fill: score >= i + 1 ? COLORS.BLUE_LIGHT : COLORS.WHITE,
        border: score >= i + 1 ? { color: COLORS.WHITE, pt: 1 } : undefined,
      },
    }));

    if (reverse) {
      return cells.reverse();
    }

    return cells;
  };

  const differentiatorsTable = [
    [
      {
        text: "",
        options: { colspan: 1, ...TEXT_OPTIONS.columnTitle, colW: 0.4 },
      },
      {
        text: "Differentiators",
        options: {
          ...TEXT_OPTIONS.caption,
          align: "left",
          valign: "middle",
          colspan: 3,
          fill: COLORS.BLUE_TABLE,
        },
      },
      {
        text: "◄  STRENGTH",
        options: {
          ...TEXT_OPTIONS.columnTitle,
          align: "left",
          valign: "middle",
          colspan: 4,
        },
      },
      { text: "", options: { colspan: 1, ...TEXT_OPTIONS.columnTitle } },
      {
        text: "STRENGTH  ►",
        options: {
          ...TEXT_OPTIONS.columnTitle,
          align: "right",
          valign: "middle",
          colspan: 4,
        },
      },
      { text: "", options: { colspan: 3, ...TEXT_OPTIONS.columnTitle } },
    ],
    ...map(leadershipSpanEvaluations, (row) => [
      {
        text: "⟩",
        options: { ...TEXT_OPTIONS.body, align: "left", valign: "middle" },
      },
      {
        text: get(row, "meta.left", ""),
        options: {
          ...TEXT_OPTIONS.body,
          align: "left",
          valign: "middle",
          colspan: 3,
        },
      },
      ...getSpanScoreCells(meanBy(row.evaluations, "meta.score_left"), true),
      {
        text: "◄►",
        options: {
          ...TEXT_OPTIONS.body,
          align: "center",
          valign: "middle",
          fontSize: 8,
          color: COLORS.GRAY,
        },
      },
      ...getSpanScoreCells(meanBy(row.evaluations, "meta.score_right")),
      {
        text: get(row, "meta.right", ""),
        options: {
          ...TEXT_OPTIONS.body,
          align: "right",
          valign: "middle",
          colspan: 3,
        },
      },
    ]),
  ];

  slide.addTable(
    differentiatorsTable as any,
    {
      x: LEFT_COLUMN_X + 14.96 / 2 - 0.1,
      y: 5.67,
      h: 2.4,
      colW: 0.5,
      rowH: 0.5,
      colspan: 16,
      fill: COLORS.WHITE,
    } as any
  );
};
